import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

export default function MessageBox({
  type = 'info',
  page = 'false',
  children,
  ...rest
}) {
  return (
    <Container {...rest}>
      <span>{children}</span>
    </Container>
  );
}

MessageBox.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

// MessageBox.defaultProps = {
//   type: 'info',
//   page: 'false',
// }
